export const chatbot = {
    providers: {
        nuvemshop: "Nuvemshop",
        shopify: "Shopify",
        woocommerce: "Woocommerce",
        magento: "Magento",
        prestashop: "PrestaShop",
        wix: "Wix",
        tray: "Tray Commerce",
        vtex: "VTEX",
        mercadoshops: "Mercado Shops",
        wordpress: "WordPress",
    }
}